import { Link as LinkIcon } from '@mui/icons-material';
import { Divider, Link, Stack } from '@mui/material';
import type { PartnerDetails } from '../../hooks/useGetPartnerInformation';

interface Props {
  website?: PartnerDetails['websiteUrl'];
  onClick: () => unknown;
}

export const TeamWebsiteItem = ({ website, onClick }: Props) => {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: website ? 'flex-start' : 'center', gap: 1 }}
    >
      <LinkIcon fontSize="small" sx={{ color: 'action.active', mt: 0.25 }} />
      {website ? (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={website}
          onClick={onClick}
        >
          {website}
        </Link>
      ) : (
        <Divider sx={{ width: (theme) => theme.spacing(3.5) }} />
      )}
    </Stack>
  );
};
